import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import 'rxjs/add/operator/map';
import { Storage } from '@ionic/storage';

import {TranslateService} from 'ng2-translate/ng2-translate';
import { AlertController, Platform, LoadingController } from 'ionic-angular';
import { ToastController } from 'ionic-angular';


/*
  Generated class for the GlobalVars provider.

  See https://angular.io/docs/ts/latest/guide/dependency-injection.html
  for more info on providers and Angular 2 DI.
*/


@Injectable()
export class GlobalVars {
 
    public userSettings:any;
    public generalVars:any;
    public showInstructions: any = false;
    public isRTL: any = false;
    public finishedLoadSettings: any = false;
    public allContacts: any;
    public ggDownload: any = 'http://GateGoing.com';
    public userLanguage: any;

    public registration: any = {};
    
    public ipCountry: any = 'il';

    public globalLoader = null;

    
//    public userId:any;
    public registrationId:any;
//    public lastSummaryId:any;
//    public lastEntryDate:any;
//    public lastTopicId:any;
//    public lastGlobal:any;
//    public lastAnonymous:any;

    public backbutton:any = 0;
    public doingTerms:any = false;
    public isNewUser:any = false;
    public iconList:any;
    public colorList:any;
    
    public userLanguages:any;
    public devices:any;
//    public alreadyAskedUsername: any = false;
//    public alreadyAskedCommentsUsername: any = false;
    public checkInIsDone: any = false;
//    public currentStartPageItem: any = {};



    public msgPleaseWait:any = "Please wait...";
    public msgBackAgain:any = "Press back again to exit";
    public msgYes:any = "Yes";
    public msgNo:any = "No";
    public msgOK:any = "OK";
    public msgCancel:any = "Cancel";
    public msgClose:any = "Close";
    public msgView:any = "View";
    public msgContinue:any = "Continue";

    public msgMinutes:any = "Minutes";
    public msgMuted:any = "Muted";
    public msgSave:any = "Save";
    public msgLoading:any = "Loading...";
    public msgOops:any = "Oops!";
    public msgError:any = "Error";
    public msgUnableToReach:any = "We are unable to reach GateGoing at this time, please try again later.";
    public msgGone:any = "Gone";
    public msgUndo:any = "UNDO";
    public msgSearch:any = "Search";
    public msgGo:any = "Go";
    public msgEdit:any = "Edit";

 

    public appVersion:any = 'unknown';
   public doneTranslate:any = false;


    constructor(public http: Http, private translate: TranslateService, public alertCtrl: AlertController, public toastCtrl: ToastController, public platform: Platform, public loadingCtrl: LoadingController, public storage : Storage) {
        console.log('Hello GlobalVars Provider');
        this.userSettings = {};
        this.generalVars = {};
  //       this.userLanguages = ['ab','ak'];
        
        this.colorList = [];

        var oneColor:any = {};
        oneColor.color = '#387EF5';
        this.colorList.push(oneColor);
        
        oneColor = {};
        oneColor.color = '#FF0000';
        this.colorList.push(oneColor);
        
        oneColor = {};
        oneColor.color = '#00cc00';
        this.colorList.push(oneColor);
        
        oneColor = {};
        oneColor.color = '#F2EA02';
        this.colorList.push(oneColor);
        
        oneColor = {};
        oneColor.color = '#FF00FF';
        this.colorList.push(oneColor);
        
        oneColor = {};
        oneColor.color = '#1aa3ff';
        this.colorList.push(oneColor);
        
        oneColor = {};
        oneColor.color = '#ffa31a';
        this.colorList.push(oneColor);
        
        oneColor = {};
        oneColor.color = '#9D00FF';
        this.colorList.push(oneColor);
        
        oneColor = {};
        oneColor.color = '#006600';
        this.colorList.push(oneColor);
        
        this.iconList = [];

        var oneIcon:any = {};
        oneIcon.icon = 'home';
        this.iconList.push(oneIcon);
        oneIcon = {};
        oneIcon.icon = 'planet';
        this.iconList.push(oneIcon);
        
        oneIcon = {};
        oneIcon.icon = 'ionic';
        this.iconList.push(oneIcon);
        
        oneIcon = {};
        oneIcon.icon = 'american-football';
        this.iconList.push(oneIcon);
        
        oneIcon = {};
        oneIcon.icon = 'aperture';
        this.iconList.push(oneIcon);
        
        oneIcon = {};
        oneIcon.icon = 'basketball';
        this.iconList.push(oneIcon);
        
        oneIcon = {};
        oneIcon.icon = 'bicycle';
        this.iconList.push(oneIcon);
        
        oneIcon = {};
        oneIcon.icon = 'boat';
        this.iconList.push(oneIcon);
        
        oneIcon = {};
        oneIcon.icon = 'body';
        this.iconList.push(oneIcon);
        
        oneIcon = {};
        oneIcon.icon = 'bonfire';
        this.iconList.push(oneIcon);
        
        oneIcon = {};
        oneIcon.icon = 'bus';
        this.iconList.push(oneIcon);
        
        oneIcon = {};
        oneIcon.icon = 'car';
        this.iconList.push(oneIcon);
        
        oneIcon = {};
        oneIcon.icon = 'cart';
        this.iconList.push(oneIcon);
        
        oneIcon = {};
        oneIcon.icon = 'cog';
        this.iconList.push(oneIcon);
        
        oneIcon = {};
        oneIcon.icon = 'construct';
        this.iconList.push(oneIcon);
        
        oneIcon = {};
        oneIcon.icon = 'flask';
        this.iconList.push(oneIcon);
        
        oneIcon = {};
        oneIcon.icon = 'football';
        this.iconList.push(oneIcon);
        
        oneIcon = {};
        oneIcon.icon = 'game-controller-b';
        this.iconList.push(oneIcon);
        
        oneIcon = {};
        oneIcon.icon = 'glasses';
        this.iconList.push(oneIcon);
        
        oneIcon = {};
        oneIcon.icon = 'globe';
        this.iconList.push(oneIcon);
        
        oneIcon = {};
        oneIcon.icon = 'ionitron';
        this.iconList.push(oneIcon);
        
        oneIcon = {};
        oneIcon.icon = 'jet';
        this.iconList.push(oneIcon);
        
        oneIcon = {};
        oneIcon.icon = 'nuclear';
        this.iconList.push(oneIcon);
        
        oneIcon = {};
        oneIcon.icon = 'restaurant';
        this.iconList.push(oneIcon);
        
        oneIcon = {};
        oneIcon.icon = 'school';
        this.iconList.push(oneIcon);
        
        oneIcon = {};
        oneIcon.icon = 'snow';
        this.iconList.push(oneIcon);
        
        oneIcon = {};
        oneIcon.icon = 'subway';
        this.iconList.push(oneIcon);
        
       oneIcon = {};
        oneIcon.icon = 'tennisball';
        this.iconList.push(oneIcon);
        
       oneIcon = {};
        oneIcon.icon = 'train';
        this.iconList.push(oneIcon);
        
       oneIcon = {};
        oneIcon.icon = 'trophy';
        this.iconList.push(oneIcon);
        
        
 //      this.loadSettings(false);
        
    }

    translateGlobalMessages(){
        if (this.doneTranslate)
            return;
        this.doneTranslate = true;
        
        
        this.translate.get(this.msgContinue, null).subscribe(localizedValue =>{
            this.msgContinue = localizedValue;
        });
       this.translate.get(this.msgOops, null).subscribe(localizedValue =>{
            this.msgOops = localizedValue;
        });
        this.translate.get(this.msgError, null).subscribe(localizedValue =>{
            this.msgError = localizedValue;
        });
        this.translate.get(this.msgUnableToReach, null).subscribe(localizedValue =>{
            this.msgUnableToReach = localizedValue;
        });
        this.translate.get(this.msgPleaseWait, null).subscribe(localizedValue =>{
            this.msgPleaseWait = localizedValue;
        });
        this.translate.get(this.msgBackAgain, null).subscribe(localizedValue =>{
            this.msgBackAgain = localizedValue;
        });
        this.translate.get(this.msgYes, null).subscribe(localizedValue =>{
            this.msgYes = localizedValue;
        });
        this.translate.get(this.msgNo, null).subscribe(localizedValue =>{
            this.msgNo = localizedValue;
        });
        this.translate.get(this.msgOK, null).subscribe(localizedValue =>{
            this.msgOK = localizedValue;
        });
        this.translate.get(this.msgCancel, null).subscribe(localizedValue =>{
            this.msgCancel = localizedValue;
        });
        this.translate.get(this.msgClose, null).subscribe(localizedValue =>{
            this.msgClose = localizedValue;
        });
        this.translate.get(this.msgView, null).subscribe(localizedValue =>{
            this.msgView = localizedValue;
        });
        this.translate.get(this.msgSave, null).subscribe(localizedValue =>{
            this.msgSave = localizedValue;
        });
        this.translate.get(this.msgMinutes, null).subscribe(localizedValue =>{
            this.msgMinutes = localizedValue;
        });
        this.translate.get(this.msgMuted, null).subscribe(localizedValue =>{
            this.msgMuted = localizedValue;
        });
        this.translate.get(this.msgSave, null).subscribe(localizedValue =>{
            this.msgSave = localizedValue;
        });
        this.translate.get(this.msgLoading, null).subscribe(localizedValue =>{
            this.msgLoading = localizedValue;
        });
       this.translate.get(this.msgGone, null).subscribe(localizedValue =>{
            this.msgGone = localizedValue;
        });
       this.translate.get(this.msgUndo, null).subscribe(localizedValue =>{
            this.msgUndo = localizedValue;
        });
       this.translate.get(this.msgSearch, null).subscribe(localizedValue =>{
            this.msgSearch = localizedValue;
        });
       this.translate.get(this.msgGo, null).subscribe(localizedValue =>{
            this.msgGo = localizedValue;
        });
      this.translate.get(this.msgEdit, null).subscribe(localizedValue =>{
            this.msgEdit = localizedValue;
        });
        
    }



    startLoader(){
        this.globalLoader = this.loadingCtrl.create({
          content: this.msgPleaseWait
      });
      this.globalLoader.present();
    }

    showAlert(title, msg) {
        
        this.translate.get(title, null).subscribe(localizedValue =>{
            title = localizedValue;
            
            this.translate.get(msg, null).subscribe(localizedValue =>{
            msg = localizedValue;
                
                let alert = this.alertCtrl.create({
                  title: title,
                  subTitle: msg,
                  buttons: [this.msgOK]
                });
                alert.present();
                
            });
        });                
    }

    endGlobalLoader(){
        if (this.globalLoader)
            this.globalLoader.dismiss();
        this.globalLoader = null;
    }

    startGlobalLoader(message){
        this.translate.get(message, null).subscribe(localizedValue =>{
            message = localizedValue;

    
            this.globalLoader = this.loadingCtrl.create({
                  content: message
              });
              this.globalLoader.present();
        });
    }

    showToast(message,duration,location) {
        this.translate.get(message, null).subscribe(localizedValue =>{
            message = localizedValue;
           

                let toast = this.toastCtrl.create({
                  message: message,
                  duration: 2000,
                  position: 'middle'
                });

                toast.present(toast);
           
        });
      }

    loadSettings(clearAll){
        console.log('In loadSettings');
        return new Promise(resolve => {
            
            if (clearAll){
                this.userSettings = {};
                this.generalVars = {};
               this.generalVars.timesAppStarted=0;
                this.showInstructions = true;
                resolve(true);
            }else{
                this.storage.get('devices').then((devices) => {
                    this.devices = devices;
                 this.storage.get('userSettings').then((userSettings) => {
                    this.userSettings = userSettings||{};
                       console.log("GOT userSettings: "+JSON.stringify(this.userSettings));
                 this.storage.get('generalVars').then((generalVars) => {
                        this.generalVars = generalVars||{};

                        if (!this.generalVars.timesAppStarted)
                            this.generalVars.timesAppStarted=0;
            //            console.log("I'm here this.generalVars.warnProperText :"+this.generalVars.warnProperText)
                        /*
                        if (!this.generalVars.warnProperText)
                            this.generalVars.warnProperText=10;
                        else
                            this.generalVars.warnProperText=-10;
                        */
                        this.generalVars.timesAppStarted++;
                        if (this.generalVars.timesAppStarted < 10)
                            this.showInstructions = true;
            //            console.log('---Loaded userSettings: '+JSON.stringify(this.userSettings));
            //            console.log('---Loaded generalVars: '+JSON.stringify(this.generalVars));
                        this.finishedLoadSettings = true;
                        resolve(true);
                    });

                });
                });
            }
        });
    }

    saveSettings(){
  //      console.log('---Saving settings: '+JSON.stringify(this.userSettings));
        this.storage.set('userSettings',this.userSettings);
        this.storage.set('generalVars',this.generalVars);
        this.storage.set('devices',this.devices);
//        console.log("SAVING DEVICES: "+JSON.stringify(this.devices));
//        this.storage.set('generalVars',null);
    }

    clearSettings(){
        this.storage.clear();
        
    }
}



// WEBPACK FOOTER //
// ./src/providers/global-vars.ts